<template>
  <v-col>
    <div class="bold-h1 mb-10" v-if="promotion">
      {{
        promotion.heading != null && promotion.heading != ""
          ? promotion.heading
          : $t("offer") +
            " - " +
            (promotion.minQuantity > 1 ? promotion.minQuantity + " för " : "") +
            promotion.discountValue +
            " kr" +
            (promotion.minQuantity > 1 ? "" : "/st")
      }}
    </div>
    <div class="bold-h1 mb-10" v-else>{{ $t("offer") }}</div>
    <v-row v-if="loading" align="center" justify="center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular
    ></v-row>

    <AllProducts v-else :products="allProducts" @loadMore="handleLoadMore" />
  </v-col>
</template>

<script>
import AllProducts from "../components/AllProducts.vue";
import CategoryProductAPI from "@/api/CategoryProductAPI";
import { mapState } from "vuex";
import { useHead } from "@unhead/vue";
export default {
  name: "Offer",
  emits: ["loadMore"],
  components: {
    AllProducts,
  },
  data() {
    return {
      allProducts: [],
      loading: true,
      promotion: null,
      page: 1,
      id: null,
    };
  },
  activated() {
    useHead({
      title: "Erbjudanden på NearbyStore",
      meta: [
        {
          hid: "description",
          name: "description",
          content: "Extra bra priser varje vecka hos NearbyStore",
        },
      ],
      __key: "recipeHead",
    });
  },
  computed: {
    ...mapState(["currentLang"]),
  },
  async mounted() {
    this.id = this.$route.params.id;
    await this.fetchProducts();
    this.loading = false;
  },
  watch: {
    currentLang(newVal) {
      this.translateProducts();
    },
    $route: async function (newRoute, oldRoute) {
      console.log(newRoute.name);
      if (newRoute.name == "offer" && newRoute.params.id != this.id) {
        console.log(newRoute.params.id);
        console.log(this.$route.params.id);
        console.log(this.id);
        this.promotion = null;
        this.loading = true;
        this.allProducts = [];
        this.page = 1;
        this.id = this.$route.params.id;
        await this.fetchProducts();
        this.loading = false;
      }
    },
  },
  methods: {
    async translateProducts() {
      try {
        const limit = this.allProducts.length;
        const response = await CategoryProductAPI.getProducts({
          page: this.page,
          promotionId: this.id,
        });
        this.allProducts = response.data;
        this.promotion = this.allProducts[0].promotion;
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    },
    async fetchProducts() {
      try {
        console.log(this.id);
        const response = await CategoryProductAPI.getProducts({
          page: this.page,
          promotionId: this.id,
        });
        this.allProducts = [...this.allProducts, ...response.data];
        console.log(this.allProducts[0]);
        console.log(this.allProducts[0].promotion);
        this.promotion = this.allProducts[0].promotion;
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    },

    handleLoadMore() {
      this.page += 1;
      this.fetchProducts();
    },
  },
};
</script>

<style scoped>
.grid-container {
  width: 100%;
  margin-bottom: 125px;
  position: relative;
}

.phone-wrapper {
  width: 95%;
  margin: auto;
}
</style>
